import React from "react";
import OnColorContext from "../../../contexts/OnColorContext";
import FlexContainerOrg from "../../organisms/FlexContainerOrg";
import { defaultProps } from "./ItemDescriptionBoxMol.props";
import { Box, ImageWrapper, StyledImage } from "./ItemDescriptionBoxMol.styled";
function ItemDescriptionBoxMol(_ref) {
  var children = _ref.children,
    backgroundColor = _ref.backgroundColor,
    image = _ref.image,
    _ref$imageVisibilityB = _ref.imageVisibilityBreakpoint,
    imageVisibilityBreakpoint = _ref$imageVisibilityB === void 0 ? defaultProps.imageVisibilityBreakpoint : _ref$imageVisibilityB,
    _ref$imagePosition = _ref.imagePosition,
    imagePosition = _ref$imagePosition === void 0 ? defaultProps.imagePosition : _ref$imagePosition,
    hasImageStickyToBottom = _ref.hasImageStickyToBottom,
    imagePullUpSpaceOnLarge = _ref.imagePullUpSpaceOnLarge,
    cssPosition = _ref.cssPosition;
  return /*#__PURE__*/React.createElement(Box, {
    $backgroundColor: backgroundColor,
    $hasImage: !!image,
    $imageVisibilityBreakpoint: imageVisibilityBreakpoint,
    $imagePosition: imagePosition,
    $imagePullUpSpaceOnLarge: imagePullUpSpaceOnLarge,
    $cssPosition: cssPosition
  }, /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: backgroundColor
  }, /*#__PURE__*/React.createElement(FlexContainerOrg, {
    justifyContent: "center",
    direction: "column"
  }, children), !!image && /*#__PURE__*/React.createElement(ImageWrapper, {
    $imageVisibilityBreakpoint: imageVisibilityBreakpoint,
    $imagePosition: imagePosition,
    $hasImageStickyToBottom: hasImageStickyToBottom
  }, /*#__PURE__*/React.createElement(StyledImage, {
    $hasImageStickyToBottom: hasImageStickyToBottom,
    $imagePullUpSpaceOnLarge: imagePullUpSpaceOnLarge
  }, image))));
}
export default ItemDescriptionBoxMol;